import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const FETCH_MUNICIPALITY_REQUEST = "FETCH_MUNICIPALITY_REQUEST";
export const FETCH_MUNICIPALITY_SUCCESS = "FETCH_MUNICIPALITY_SUCCESS";
export const FETCH_MUNICIPALITY_FAILURE = "FETCH_MUNICIPALITY_FAILURE";

export const UPDATE_MUNICIPALITY_REQUEST = "UPDATE_MUNICIPALITY_REQUEST";
export const UPDATE_MUNICIPALITY_SUCCESS = "UPDATE_MUNICIPALITY_SUCCESS";
export const UPDATE_MUNICIPALITY_FAILURE = "UPDATE_MUNICIPALITY_FAILURE";


export const fetchMunicipalityList = () => {
  return async (dispatch) => {
    dispatch({ type: FETCH_MUNICIPALITY_REQUEST });
    const token = localStorage.getItem("token");

    try {
      const response = await axios.get(
        `${BASE_URL}/v1/api/admin/getMunicipalityRegList`,
        { headers: { authorization: token } }
      );

      dispatch({
        type: FETCH_MUNICIPALITY_SUCCESS,
        payload: response.data.data,
      });
    } catch (error) {
      dispatch({
        type: FETCH_MUNICIPALITY_FAILURE,
        payload: error.response?.data?.meta?.message || error.message,
      });
    }
  };
};


export const updateMunicipality = (data) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_MUNICIPALITY_REQUEST });
    const token = localStorage.getItem("token");

    try {
      const response = await axios.put(
        `${BASE_URL}/v1/api/admin/updateMunicipalityReg`,
        data,
        { headers: { authorization: token } }
      );

      dispatch({
        type: UPDATE_MUNICIPALITY_SUCCESS,
        payload: response.data,
      });

      return response.data; // for redirect/navigation
    } catch (error) {
      dispatch({
        type: UPDATE_MUNICIPALITY_FAILURE,
        payload: error.response?.data?.meta?.message || error.message,
      });
      throw error;
    }
  };
};